// extracted by mini-css-extract-plugin
export var control = "FormCheckboxField-module--control--yQiXb";
export var item = "FormCheckboxField-module--item--E7qlE";
export var itemLabel = "FormCheckboxField-module--itemLabel--1J5aS";
export var list = "FormCheckboxField-module--list--Y6Ar4";